<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="600px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="priceListName === 'papers'">
                        Import cennika papierów
                    </template>
                    <template v-else>
                        Import cennika materiałów
                    </template>
                </h1>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-file-input
                            v-model="currentPriceListFile"
                            label="Plik cennika"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            counter
                            placeholder="Wybierz plik"
                            prepend-icon="mdi-paperclip"
                            outlined
                            dense
                            :error-messages="currentPriceListFileErrors"
                            :show-size="1000"
                        />
                    </v-col>
                    <v-col cols="12">
                        <div v-if="actionLoading.fileUploading" class="d-inline-flex align-center">
                            <v-overlay
                                color="white"
                                opacity="0.85"
                                absolute
                                :value="actionLoading.fileUploading"
                            >
                                <v-container class="pa-0">
                                    <v-row justify="center">
                                        <v-col cols="auto">
                                            <v-progress-circular
                                                :rotate="-90"
                                                :size="120"
                                                :width="4"
                                                :value="uploadingProgressValue"
                                                color="primary"
                                            >
                                                {{ uploadingProgressValue }}
                                            </v-progress-circular>
                                        </v-col>
                                    </v-row>
                                    <v-row justify="center">
                                        <v-col cols="auto">
                                            <v-btn
                                                color="error"
                                                small
                                                data-sentry-label="Anuluj"
                                                outlined
                                                @click="abortUploadingPriceListFileAttachment"
                                            >
                                                Anuluj
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-overlay>
                        </div>
                    </v-col>
                </v-row>
            </div>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Potwierdź"
                    :disabled="!currentPriceListFile"
                    @click="onSave"
                >
                    Wyślij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { appConfig } from '@/config'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'PriceListDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        reportData: {
            type: Object,
            default: null
        },
        priceListName: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            currentPriceListFile: null,
            actionLoading: {
                fileUploading: false,
                fileRemoving: false
            },
        }
    },
    validations() {
        return {
            currentPriceListFile: {
                isValid: (value) => {
                    if (value) {
                        return value.size < appConfig.configurations.materials.attachmentSize * 1024 * 1024
                    }

                    return true
                },
                isNameValid: (value) => {
                    if (value) {
                        return value.name.includes(this.priceListName)
                    }

                    return true
                }
            }
        }
    },
    computed: {
        uploadingProgressValue() {
            return this.$store.state.common.progress.value
        },
        currentPriceListFileErrors() {
            if (!this.currentPriceListFile) return

            const errors = []

            if (!this.$v.currentPriceListFile.$dirty) return errors
            !this.$v.currentPriceListFile.isValid && errors.push(`Przekroczono dopuszczalny rozmiar pliku: ${appConfig.configurations.materials.attachmentSize}MB.`)

            if (!this.$v.currentPriceListFile.$dirty) return errors
            !this.$v.currentPriceListFile.isNameValid && errors.push(`Wymagana nazwa pliku: ${this.priceListName}.xlsx`)

            return errors
        },
    },
    methods: {
        abortUploadingPriceListFileAttachment() {
            const action = this.priceListName === 'papers' ? 'importPapersPriceList' : 'importMaterialsPriceList'

            this.$store.dispatch(`configurations/${action}`, {
                formData: null,
                abort: true
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        onSave() {
            this.$v.currentPriceListFile.$touch()

            if (this.$v.currentPriceListFile.$invalid) return

            const formData = new FormData()

            this.priceListFile = this.currentPriceListFile

            formData.append('file', this.currentPriceListFile)

            this.actionLoading.fileUploading = true

            const action = this.priceListName === 'papers' ? 'importPapersPriceList' : 'importMaterialsPriceList'

            this.$store.dispatch(`configurations/${action}`, {
                formData: formData,
                abort: false
            })
                .then(() => {
                    this.currentPriceListFile = null
                    this.$emit('on-save')
                    this.onClose()
                })
                .catch(error => {
                    if (error.message !== 'canceled') {
                        errorHandler(error)
                    }
                })
                .finally(() => {
                    this.actionLoading.fileUploading = false
                })

        },
        onClose() {
            setTimeout(() => {
                this.$v.$reset()
                this.currentPriceListFile = null
            }, 500)
            this.$emit('on-close')
        },
    }
}
</script>